'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var strings = require('../helpers/strings.js');
var date = require('../helpers/date.js');
require('../helpers/arrays.js');
require('../helpers/language.js');
require('../helpers/numbers.js');
require('../helpers/currency.js');
require('../helpers/dom.js');
require('../helpers/debounce.js');
require('../helpers/throttle.js');
require('../helpers/functions.js');
require('../helpers/session.js');
require('../helpers/forms.js');
require('../helpers/keys.js');
require('../helpers/game.js');
require('../helpers/game-category.js');
require('../helpers/script.js');
require('../helpers/events.js');
require('../helpers/password.js');
require('../helpers/storage.js');
require('../helpers/theming.js');
require('../helpers/objects.js');
require('../helpers/slots.js');
require('../helpers/phone.js');

function validAge(legalAge) {
  return (model) => {
    const date = extractDate(model);
    if (!date) {
      return false;
    }
    const legalDate = new Date();
    legalDate.setFullYear(legalDate.getFullYear() - legalAge);
    return date.getTime() < legalDate.getTime();
  };
}
const reasonableDateOfBirth = (model) => {
  const date = extractDate(model);
  if (!date) {
    return false;
  }
  const pastLimitDate = new Date();
  pastLimitDate.setFullYear(pastLimitDate.getFullYear() - 100);
  return date > pastLimitDate && date < new Date();
};
const acceptedExpiryDate = (props) => {
  const { model, futureDateStart = new Date(), futureYearLimit } = props;
  const date = extractDate(model);
  if (!date) {
    return false;
  }
  const currentDate = new Date();
  const maxFutureYear = futureDateStart.getFullYear() + futureYearLimit;
  const maxExpiryDate = new Date(maxFutureYear, futureDateStart.getMonth(), futureDateStart.getDate());
  if (date > maxExpiryDate || date < currentDate || date < futureDateStart) {
    return false;
  }
  return true;
};
function maxValidAge(maxAge) {
  return (model) => {
    const date = extractDate(model);
    if (!date) {
      return false;
    }
    const legalDate = new Date();
    legalDate.setFullYear(legalDate.getFullYear() - maxAge);
    return date.getTime() > legalDate.getTime();
  };
}
function extractDate(field) {
  const day = strings.toNumber(field.day);
  const month = strings.toNumber(field.month);
  const year = strings.toNumber(field.year);
  if (!validDay(field.day, field) || !validMonth(field.month) || !validYear(field.year)) {
    return false;
  }
  return new Date(year, month - 1, day);
}
function validDay(_, field) {
  const { day: strDay, month: strMonth, year: strYear } = field;
  const day = strings.toNumber(strDay);
  const month = strings.toNumber(strMonth);
  const year = strings.toNumber(strYear);
  if (month && year && day && day > date.daysInMonth(month, year)) {
    return false;
  }
  return day !== null && day >= 1 && day <= 31;
}
function validMonth(value) {
  const month = strings.toNumber(value);
  return month >= 1 && month <= 12;
}
function validYear(value) {
  const year = strings.toNumber(value);
  return year >= 1890 && year <= 2099;
}

exports.acceptedExpiryDate = acceptedExpiryDate;
exports.maxValidAge = maxValidAge;
exports.reasonableDateOfBirth = reasonableDateOfBirth;
exports.validAge = validAge;
exports.validDay = validDay;
exports.validMonth = validMonth;
exports.validYear = validYear;
